import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FloatingLabelInput from '../../components/FloatingLabelInput';
import UtilsService from '../../../services/UtilsService';
import { seedQualityPatternPropType } from './SeedQualityPatterns';
import FormModal from '../../components/FormModal';
import FormService from '../../../services/FormService';

export const fields = [
  {
    id: 'description',
    label: 'Descrição',
    type: 'text',
    field: 'description',
    validations: [
      (v) => !!v || 'Descrição é obrigatória',
    ],
    visible: true,
    autoFocus: true,
    required: true,
  },
  {
    id: 'priority',
    label: 'Prioridade',
    type: 'number',
    field: 'priority',
    validations: [
      (v) => !!v || 'Prioridade é obrigatória',
    ],
    visible: true,
    required: true,
  },
];

const emptyState = {
  description: '',
  priority: '',
};

export const buildSeedQualityPattern = (seedQualityPattern) => {
  if (FormService.hasData) {
    return FormService.data;
  }

  if (seedQualityPattern) {
    return {
      description: seedQualityPattern.description,
      priority: seedQualityPattern.priority,
    };
  }

  return emptyState;
};

const EditSeedQualityPatternModal = (props) => {
  const { routes, seedQualityPattern } = props;
  const urlSeedQualityPattern = routes.seedQualityPatternsPath;

  const [state, setState] = useState(() => buildSeedQualityPattern(seedQualityPattern));
  const [open, setOpen] = useState(true);
  const [edit] = useState(Boolean(seedQualityPattern));

  const validInputs = () => UtilsService.validateState(fields, state);
  const handleChange = (id, value) => {
    setState({
      ...state,
      [id]: value,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getUrlForm = () => {
    if (edit) {
      return `${urlSeedQualityPattern}/${seedQualityPattern.id}`;
    }
    return urlSeedQualityPattern;
  };

  const onFormSubmit = () => { FormService.data = state; };

  return (
    <>
      <FormModal
        title="Padrão de Qualidade"
        open={open}
        formForProps={{
          method: edit ? 'put' : 'post',
          url: getUrlForm(),
          onSubmit: onFormSubmit,
        }}
        actionsButtons={{
          confirm: {
            label: 'Salvar',
            disabled: !validInputs(),
          },
          cancel: {
            onClick: handleClose,
          },
        }}
      >

        {fields.map((
          {
            id, label, type, field, validations, placeholder, format, required, autoFocus,
          },
        ) => (
          <FloatingLabelInput
            key={field}
            id={id}
            label={label}
            type={type}
            validationRules={validations}
            value={state[id]}
            onChange={handleChange}
            name={field}
            placeholder={placeholder}
            format={format}
            required={required}
            autoFocus={autoFocus}
          />
        ))}
      </FormModal>
      )
    </>
  );
};

EditSeedQualityPatternModal.propTypes = {
  seedQualityPattern: seedQualityPatternPropType,
  routes: PropTypes.objectOf(PropTypes.string),
};

export default EditSeedQualityPatternModal;
